import { AreaState, GroupWithPermissions } from "./types";

export function getDefaultState(): AreaState {
	return {
		AreaList: Array<GroupWithPermissions>(),
		areaDictionary: {}
	};
}
